export default __webpack_public_path__ + "static/media/Landing4.42142c44.jpg";